import { NgModule, inject } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { CoreEffects } from '@next/core-lib';
import { AgrAppModule } from '@next/core-lib/app';
import { provideAgrCore } from '@next/core-lib/app';
import { I18nBrowserEffects } from '@next/core-lib/browser';
import { I18nEffects } from '@next/core-lib/i18n';
import { NavigationEffects } from '@next/core-lib/navigation';
import { provideAgrRouterStore } from '@next/core-lib/router-store';
import { provideAgrSettings } from '@next/core-lib/settings';
import { SiteEffects } from '@next/core-lib/site';
import { AgrWrapperSiteSidenavModule } from '@next/core-lib/wrapper-site-sidenav';
import { provideEffects } from '@ngrx/effects';
import { provideStore } from '@ngrx/store';

import { AppComponent } from './app.component';
import { DairyresultsModule } from './dairyresults/dairyresults.module';
import { EconomyComponent } from './economy/economy.component';
import { FeedModule } from './feed/feed.module';
import { FertilityModule } from './fertility/fertility.module';
import { HealthModule } from './health/health.module';

import { HomepageComponent } from './homepage/homepage.component';
import { SharedModule } from './shared/shared.module';
import { SustainabilityModule } from './sustainability/sustainability.module';
import { TechnicalResultModule } from './technical-result/technical-result.module';

@NgModule({
  imports: [
    DairyresultsModule,
    FeedModule,
    FertilityModule,
    HealthModule,
    SharedModule,
    TechnicalResultModule,
    SustainabilityModule,
    AgrAppModule,
    AgrWrapperSiteSidenavModule,
    AppComponent,
    EconomyComponent,
    HomepageComponent,
  ],
  providers: [
    provideStore(
      {},
      {
        runtimeChecks: {
          strictStateImmutability: true,
          strictActionImmutability: true,
          strictStateSerializability: true,
          strictActionSerializability: true,
        },
      },
    ),
    provideAgrRouterStore(),
    provideAgrCore(),
    provideAgrSettings(),
    provideEffects([CoreEffects, I18nEffects, I18nBrowserEffects, SiteEffects, NavigationEffects]),
  ],
})
export class AppModule {
  constructor() {
    const matIcon = inject(MatIconRegistry);
    const sanitizer = inject(DomSanitizer);

    matIcon.addSvgIconLiteral(
      'home-dashboard',
      sanitizer.bypassSecurityTrustHtml(
        // eslint-disable-next-line max-len
        `<svg xmlns="http://www.w3.org/2000/svg" height="100%" viewBox="0 -960 960 960" width="100%" fit="" preserveAspectRatio="xMidYMid meet" focusable="false"><path d="M407-325q23 23 66.5 21.5T537-336l216-339-335 219q-30 20-32 64t21 67Zm71-474q57 0 119 18.5T716-717l-52 37q-45-30-96.5-44.5T477.978-739q-140.472 0-239.225 100.215Q140-538.569 140-396.017 140-351 152.5-305q12.5 46 35.5 85h579q22-36 35-84t13-94q0-42-12.5-90.5T758-578l39-52q38 56 57 112.5T875-404q2 60-12 113t-41 98q-12 23-25.5 28t-33.5 5H192q-17 0-33.5-8.5T134-193q-26-48-40-97.5T80-396q0-83 31.5-156.5t85.5-128Q251-735 323.68-767T478-799Zm-9 331Z"></path></svg>`,
      ),
    );

    // This icon is in the Google Material Symbols font while we are still using the Google Material Icons (deprecated) font
    // Once we migrate to the Google Material Symbols font, we can remove this icon
    matIcon.addSvgIconLiteral(
      'lab_profile',
      sanitizer.bypassSecurityTrustHtml(
        // eslint-disable-next-line max-len
        `<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px"><path d="M320-480h320v-80H320v80Zm0-160h320v-80H320v80Zm478 499L636-352q-17-23-42-35.5T540-400H160v-400q0-33 23.5-56.5T240-880h480q33 0 56.5 23.5T800-800v640q0 5-.5 9.5T798-141ZM240-80q-33 0-56.5-23.5T160-160v-160h380q10 0 18.5 4.5T573-303L741-83q-5 2-10.5 2.5T720-80H240Z"/></svg>`,
      ),
    );
  }
}
